/* Shto SCP Electrolytes: flavor picker for the buy box. Reads everything from data- attributes on the icon buttons.
   Updates the flavor name, the desktop price, the button (price or SOLD OUT), the variant id in the theme's product form
   and the main photo (fetched ahead and decoded before it swaps, see "Photos" below). Never touches the address. Add to cart itself is the theme's <product-form> (assets/product.js). */
(function () {
  function ensureProductForm(root) {
    if (customElements.get('product-form')) return;
    var holder = root.querySelector('[data-shto-elx-productjs]');
    if (!holder || document.querySelector('script[data-shto-productjs]')) return;
    var s = document.createElement('script');
    s.src = holder.getAttribute('data-shto-elx-productjs');
    s.defer = true;
    s.setAttribute('data-shto-productjs', '');
    document.head.appendChild(s);
  }

  function init(root) {
    if (root.dataset.shtoElxOn) return;
    root.dataset.shtoElxOn = '1';
    ensureProductForm(root);

    var flavors = Array.prototype.slice.call(root.querySelectorAll('[data-shto-elx-flavor]'));
    var nameEl = root.querySelector('[data-shto-elx-name]');
    var priceEl = root.querySelector('[data-shto-elx-price]');
    var idInput = root.querySelector('[data-shto-elx-id]');
    var add = root.querySelector('[data-shto-elx-add]');
    var addLabel = root.querySelector('[data-shto-elx-add-label]');
    var photo = root.querySelector('[data-shto-elx-photo]');
    var form = root.querySelector('product-form');

    function select(btn) {
      flavors.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      var d = btn.dataset;
      var available = d.available === 'true';
      if (nameEl) nameEl.textContent = d.name;
      if (priceEl) priceEl.textContent = d.price;
      if (idInput) idInput.value = d.variantId;
      if (add) {
        add.disabled = !available;
        if (addLabel) addLabel.textContent = available ? add.dataset.label + add.dataset.sep + d.price : add.dataset.soldout;
      }
      if (photo && d.src && photo.getAttribute('src') !== d.src) swap(btn);
    }

    // Photos. Each flavor's photo is fetched in the size this screen needs: a detached image with the same srcset and sizes
    // as the main photo, so the browser picks the same file the main photo will ask for. It is decoded before the swap, so
    // the old photo stays until the new one paints in the next frame (no blank frame). Fetched ahead after the page is idle
    // (one at a time, quietly), and at once when a finger or pointer lands on an icon.
    var loads = {};
    function load(btn, urgent) {
      var d = btn.dataset;
      if (!d.src) return null;
      if (loads[d.src]) return loads[d.src];
      var im = new Image();
      im.decoding = 'async';
      if (!urgent && 'fetchPriority' in im) im.fetchPriority = 'low';
      if (photo) im.sizes = photo.getAttribute('sizes') || '';
      if (d.srcset) im.srcset = d.srcset;
      im.src = d.src;
      var p = (im.decode ? im.decode() : Promise.reject()).catch(function () {
        return new Promise(function (res) { if (im.complete) res(); else { im.onload = res; im.onerror = res; } });
      });
      loads[d.src] = p;
      p.shtoImg = im;
      return p;
    }
    var want = null;
    function swap(btn) {
      var d = btn.dataset;
      want = btn;
      var p = load(btn, true) || Promise.resolve();
      p.then(function () {
        if (want !== btn) return; // another flavor was picked meanwhile
        if (d.srcset) photo.setAttribute('srcset', d.srcset); else photo.removeAttribute('srcset');
        photo.setAttribute('src', d.src);
        photo.setAttribute('alt', d.alt || '');
        photo.loading = 'eager';
      });
    }
    function preloadAll() {
      if (navigator.connection && navigator.connection.saveData) return;
      var queue = flavors.filter(function (b) { return b.dataset.src && b.dataset.src !== (photo && photo.getAttribute('src')); });
      (function next() {
        var b = queue.shift();
        if (!b) return;
        var p = load(b, false);
        (p || Promise.resolve()).then(function () { idle(next); });
      })();
    }
    function idle(fn) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2000 }); else setTimeout(fn, 200); }
    if (photo) {
      if (document.readyState === 'complete') idle(preloadAll);
      else window.addEventListener('load', function () { idle(preloadAll); });
    }

    flavors.forEach(function (b, i) {
      b.tabIndex = b.classList.contains('is-selected') ? 0 : -1;
      b.addEventListener('pointerenter', function () { load(b, true); });
      b.addEventListener('touchstart', function () { load(b, true); }, { passive: true });
      b.addEventListener('focus', function () { load(b, true); });
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (e) {
        var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!step) return;
        e.preventDefault();
        var next = flavors[(i + step + flavors.length) % flavors.length];
        next.focus();
        select(next);
      });
    });
    if (!root.querySelector('[data-shto-elx-flavor].is-selected') && flavors[0]) flavors[0].tabIndex = 0;

    // One click = one add: a second submit while the first is on its way is dropped before the theme's handler sees it.
    // (Both listeners sit on the form itself, so only stopImmediatePropagation keeps the theme's from running.)
    if (form && add) {
      var busy = false;
      var done = function () { busy = false; add.classList.remove('is-busy'); add.removeAttribute('aria-busy'); };
      form.addEventListener('submit', function (e) {
        if (busy || add.disabled) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        busy = true;
        add.classList.add('is-busy');
        add.setAttribute('aria-busy', 'true');
        setTimeout(done, 8000);
      }, true);
      document.addEventListener('cart:item-added', done);
      document.addEventListener('product:variant-error', done);
    }
  }

  function boot() { document.querySelectorAll('[data-shto-elx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
